import {map, filter} from 'rxjs/operators';
import {Injectable, ModuleWithProviders, NgModule} from '@angular/core';
import {Subject} from 'rxjs';


interface BroadcastEvent {
  key: any;
  data?: any;
}

@Injectable()
export class BroadcasterService {

  private _eventBus: Subject<BroadcastEvent>;

  constructor() {
    this._eventBus = new Subject<BroadcastEvent>();
  }

  broadcast(key: any, data?: any) {
    this._eventBus.next({key, data});
  }

  on(key: any) {
    return this._eventBus.asObservable().pipe(
      filter(event => event.key === key),
      map(event => event.data),);
  }

}

@NgModule({
  imports: [],
  declarations: [],
  exports: []
})
export class BroadcasterModule {
  static forRoot(): ModuleWithProviders<BroadcasterModule> {
    return {
      ngModule: BroadcasterModule,
      providers: [BroadcasterService]
    };
  }
}
